// ** React Imports
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import FormHelperText from '@mui/material/FormHelperText'
import {
    Autocomplete,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    Fab,
    IconButton,
    Tooltip,
} from '@mui/material'

import { useNavigate, useParams } from "react-router-dom";
import { Controller, useForm } from 'react-hook-form'
import axios from 'axios'

import Icon from '../../../../components/icon';
import apiUrl from '../../../../configs/constant';
import { SyntheticEvent, useEffect, useState } from 'react';
import appInfo from '../../../../configs/app-info';
import { getDoctag, getGudang, getProses } from '../../../../api/helper';
import { useToast } from '../../../../components/ToastProvider';
import moment from 'moment';
import MsiDatagrid from '../../../../components/custom/MsiDatagridAuto';
import Swal from 'sweetalert2';
import { createFilterOptions } from '@mui/material/Autocomplete';

export default function Add() {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token
    const cabang = JSON.parse(localStorage.getItem('cabang')!)
    const navigate = useNavigate();
    const { id } = useParams();
    const { showToast, hideToast } = useToast();

    const [idD, setIdD] = useState<any>(null)
    const [listData, setListData] = useState<any[]>([])
    const [openDialog, setOpenDialog] = useState<boolean>(false)
    const [openDialogBaru, setOpenDialogBaru] = useState<boolean>(false)
    const [openDialogExisting, setOpenDialogExisting] = useState<boolean>(false)
    const [valBarang, setValBarang] = useState<any>(null)
    const [valBatch, setValBatch] = useState<any>(null)
    const [listBarang, setListBarang] = useState<any[]>([])
    const [listBatch, setListBatch] = useState<any[]>([])
    const [loading, setLoading] = useState<boolean>(false)

    interface FormInputs {
        subgudang: any,
        pic: any,
        keterangan: any,
        tgl: any,

        mmbarang_id: any,
        qty_stock: any,
        qty_opname: any,
        qty_doc: any,
        keterangan_detail: string,
        did:any,
        barang:any,
        batch:any
    }

    const defaultValues = {
    }

    const {
        control,
        watch,
        handleSubmit,
        setValue,
        getValues,
        formState: { errors }
    } = useForm<FormInputs>({ defaultValues })

    useEffect(() => {
        getMaster();
        getDetail();
        getBarangKain();
        getBatch();
    }, [])

    const getMaster = () => {
        const url = apiUrl.apiUrl + '/mm/opname-kain/detail/' + id
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const master = response.data.data
                    setValue('pic', master.pic)
                    setValue('keterangan', master.keterangan)
                    setValue('tgl', master.tgl)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }
    const getDetail = () => {
        const url = apiUrl.apiUrl + '/mm/opname-kain/list-detail/' + id
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })  
            .then(response => {
                if (response.data.success) {
                    setListData(response.data.data)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }
    const getBarangKain = () => {
        setLoading(false)
        const url = apiUrl.apiUrl + '/gudang/stock-opname/list-kain'
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListBarang(data)
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }

    const getBatch = () => {
        setLoading(false)
        const url = apiUrl.apiUrl + '/mm/opname-kain/list-kain'
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListBatch(data)
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }

    const ActionButtons = ({ row }: {
        row: any;
    }) => {
        return (
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",   // center horizontal
                    alignItems: "center",       // center vertical
                    height: "100%",             // penting kalau di dalam cell
                    width: "100%",
                    gap: 1
                }}
            >
                {/* Cetak Label */}
                <Tooltip title="Cetak Label">
                    <IconButton
                        color="primary"
                        size="small"
                        onClick={(e) => {
                            e.stopPropagation();
                            window.open(
                                `${apiUrl.baseUrl}/mm/batch/cetak-label-batch/${row.mmbarang_batch_id}`,
                                "_blank"
                            );
                        }}
                    >
                        <Icon icon="mdi:qrcode" />
                    </IconButton>
                </Tooltip>

                {/* Edit */}
                <Tooltip title="Edit">
                    <IconButton
                        color="warning"
                        size="small"
                        onClick={(e) => {
                            e.stopPropagation();
                            setValue('did',row.id);
                            setValue('mmbarang_id',row.mmbarang_id);
                            setValue('qty_stock',row.qty_stock);
                            setValue('qty_doc',row.qty_doc);
                            setValue('keterangan_detail',row.keterangan);
                            setValue('qty_opname',row.qty_actual);
                            setValue('barang',row.nama_barang)
                            setOpenDialog(true);
                        }}
                    >
                        <Icon icon="mdi:pencil" />
                    </IconButton>
                </Tooltip>

                {/* Hapus */}
                <Tooltip title="Hapus">
                    <IconButton
                        color="error"
                        size="small"
                        onClick={(e) => {
                            e.stopPropagation();
                            Swal.fire({
                                title: 'Konfirmasi',
                                text: 'Apakah anda ingin hapus data ini ?',
                                icon: 'question',
                                showCancelButton: true,
                                confirmButtonColor: '#337ab7',
                                cancelButtonColor: '#ffc107',
                                confirmButtonText: 'Hapus'
                            }).then(result => {
                                if (result.isConfirmed) {
                                    Swal.fire({
                                        title: 'Now loading',
                                        allowEscapeKey: false,
                                        allowOutsideClick: false,
                                        didOpen: () => {
                                            Swal.showLoading()
                                        }
                                    })
                    
                                    const data = {}
                                    const url = apiUrl.apiUrl + '/mm/opname-kain/delete-detail/' + row.id
                                    axios
                                        .post(url, data, {
                                            headers: { Authorization: `Bearer ${token}` }
                                        })
                                        .then(response => {
                                            if (response.data.success) {
                                                Swal.fire({
                                                    title: 'Pemberitahuan',
                                                    text: response.data.message,
                                                    icon: 'success',
                                                    timer: 1000,
                                                    timerProgressBar: true,
                                                    willClose: () => {
                                                        getDetail()
                                                    }
                                                })
                                            } else {
                                                Swal.fire({
                                                    title: 'Pemberitahuan',
                                                    text: response.data.message,
                                                    icon: 'error'
                                                })
                                            }
                                        })
                                        .catch(error => {
                                            Swal.fire({
                                                title: 'Pemberitahuan',
                                                text: error.message,
                                                icon: 'error'
                                            })
                                        })
                                }
                            })
                        }}
                    >
                        <Icon icon="mdi:delete" />
                    </IconButton>
                </Tooltip>
            </Box>

        );
    };

    const actionData = [
        {
            key: "aksi",
            flex: 1,
            sortable: false,
            minWidth: 100,
            field: "aksi",
            align: "center",
            headerAlign: "center",
            headerName: "Aksi",
            renderCell: ({ row }: { row: any }) => (
                <ActionButtons
                    row={row}
                />
            ),
        },
    ];

    const handleChangeAutocompleteBarang = (event: SyntheticEvent, newValue: any | null) => {
        setValue('mmbarang_id', newValue ? newValue.id : null)
        setValBarang(newValue)
    }
    const handleChangeAutocompleteBatch = (event: SyntheticEvent, newValue: any | null) => {
        setValue('batch', newValue ? newValue.id : null)
        setValue('qty_stock',newValue ? newValue.stock_saat_ini : 0)
        setValBatch(newValue)
    }


    // tambahkan ini di dalam komponen
    const qtyStock = watch("qty_stock");
    const qtyOpname = watch("qty_opname");

    useEffect(() => {
        if (qtyStock !== undefined && qtyOpname !== undefined) {
            const stock = parseFloat(qtyStock) || 0;
            const opname = parseFloat(qtyOpname) || 0;
            const adjustment = stock - opname;
            setValue("qty_doc", adjustment, { shouldValidate: true });
        }
    }, [qtyStock, qtyOpname, setValue]);

    const filterOptions = createFilterOptions({
        stringify: (option: any) => `${option.id} ${option.nama_barang}`
    });

    return (
        <Grid container spacing={6} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xl={12} md={12} xs={12}>
                <Fab variant='extended' color='primary' sx={{ '& svg': { mr: 1 } }} onClick={() => window.history.back()}>
                    <Icon icon='mdi:arrow-left' />
                    Kembali
                </Fab>
                <div className={'content-block dx-card'} style={{ paddingRight: 20, paddingLeft: 20, paddingBottom: 10, paddingTop: 10 }}>
                    <Typography variant='h5' sx={{ textAlign: 'center' }}>
                        Detail Opname Kain
                    </Typography>
                    <Typography variant='body1' sx={{ textAlign: 'center' }}>
                        Tanggal : <b>{moment(getValues('tgl')).format('LL')}</b>
                    </Typography>
                    <Typography variant='body1' sx={{ textAlign: 'center' }}>
                        No. Dokumen : <b>{id}</b>
                    </Typography>
                    <Divider sx={{ m: 0 }} />
                    <Grid container spacing={3} sx={{ mt: 1 }}>
                        <Grid item xs={12} md={12}>
                            <FormControl fullWidth>
                                <Controller
                                    name='pic'
                                    control={control}
                                    rules={{ required: true }}
                                    render={({ field: { value, onChange } }) => (
                                        <TextField
                                            value={value}
                                            label='PIC'
                                            onChange={onChange}
                                            error={Boolean(errors.pic)}
                                            InputProps={{ readOnly: true }}
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    )}
                                />
                                {errors.pic && (
                                    <FormHelperText sx={{ color: 'error.main' }}>PIC harus diisi</FormHelperText>
                                )}
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <FormControl fullWidth>
                                <Controller
                                    name='keterangan'
                                    control={control}
                                    render={({ field: { value, onChange } }) => (
                                        <TextField
                                            value={value}
                                            label='Keterangan'
                                            onChange={onChange}
                                            multiline
                                            rows={4}
                                            inputProps={{ readOnly: true }}
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    )}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            {/* Header + Tombol di kanan */}
                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'flex-end',
                                    mb: 1
                                }}
                            >
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    sx={{mr:3}}
                                    startIcon={<Icon icon="mdi:plus" />}
                                    onClick={() => {
                                        setValue('qty_doc', 0);
                                        setValue('qty_stock', 0);
                                        setValue('qty_opname',0);
                                        setValue('batch',null);
                                        setValBatch(null);
                                        setOpenDialogExisting(true);
                                    }}
                                >
                                    Tambah Batch Existing
                                </Button>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    startIcon={<Icon icon="mdi:plus" />}
                                    onClick={() => {
                                        setValue('qty_doc', 0);
                                        setValue('qty_stock', 0);
                                        setOpenDialogBaru(true);
                                    }}
                                >
                                    Tambah Batch Baru
                                </Button>
                            </Box>

                            {/* Datagrid */}
                            <MsiDatagrid
                                array={listData}
                                hiddenColumns={[
                                    'id','mmopname_id','mmbarang_id','mmsatuan_id','mmsatuan_doc_id','mmgudang_sub_id','mmgudang_sub_asal_id','jenis_kain','qty_doc','updated_at','updated_by','deleted_at','deleted_by','keterangan','qty_stock','qty','created_at','created_by']}
                                actions={actionData}
                            />
                        </Grid>
                    </Grid>
                </div>
            </Grid>
            <Dialog
                maxWidth={'sm'}
                fullWidth={true}
                open={openDialogBaru}
                onClose={() => setOpenDialogBaru(false)}
                aria-labelledby='form-dialog-title'
            >
                <form onSubmit={handleSubmit((data) => {
                    setOpenDialogBaru(false)
                    let url = apiUrl.apiUrl + '/mm/opname-kain/save-detail/' + id;
                    axios.post(url, data, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                        .then(response => {
                            if (response.data.success) {
                                showToast(response.data.message, 'success');
                                window.open(
                                    `${apiUrl.baseUrl}/mm/batch/cetak-label-batch/${response.data.batch_id}`,
                                    '_blank'
                                );
                                getDetail();
                            } else {
                                showToast(response.data.message, 'error');
                                setOpenDialog(false);
                            }
                        })
                        .catch(error => {
                            showToast(error.message, 'error');
                        });
                })}>
                    <DialogTitle id='form-dialog-title'>
                        <Typography variant='h6' sx={{ fontWeight: 500, color: '#212121' }}>
                            Tambah Baru Opname
                        </Typography>
                    </DialogTitle>
                    <DialogContent dividers>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={12}>
                                <FormControl fullWidth>
                                    <Autocomplete
                                        value={valBarang}
                                        options={listBarang}
                                        id='barang'
                                        isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                        getOptionLabel={(option: any) => option.nama || ""}   // ? tampilkan nama
                                        onChange={handleChangeAutocompleteBarang}
                                        renderOption={(props: any, option: any) => {
                                            return (
                                                <li {...props} key={option.id}>
                                                    {option.nama}
                                                </li>
                                            )
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                required
                                                label='Barang'
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name="qty_stock"
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                inputProps={{ readOnly: true }}
                                                fullWidth
                                                label="Quantity System / Stock"
                                                value={value}
                                                onChange={onChange}
                                                InputLabelProps={{ shrink: true }}
                                                disabled
                                            />
                                        )}
                                    />
                                    {errors.qty_stock && (
                                        <FormHelperText sx={{ color: "error.main" }}>
                                            Form ini tidak boleh kosong.
                                        </FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            {/* QTY ADJUSTMENT */}
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name="qty_doc"
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                inputProps={{ readOnly: true }}
                                                fullWidth
                                                label="Quantity Adjustment"
                                                type="number"
                                                value={value}
                                                disabled
                                                onChange={onChange}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.qty_doc && (
                                        <FormHelperText sx={{ color: "error.main" }}>
                                            Form ini tidak boleh kosong.
                                        </FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>

                            {/* QTY OPNAME */}
                            <Grid item xs={12} sm={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name="qty_opname"
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                fullWidth
                                                label="Quantity Opname"
                                                name="qty_opname"
                                                value={
                                                    value !== undefined && value !== null && value !== ""
                                                        ? (() => {
                                                            // Format value for display: replace dot with comma, add thousand separator
                                                            const str = String(value).replace(".", ",");
                                                            const [integer, decimal] = str.split(",");
                                                            let formatted = integer
                                                                ? Number(integer).toLocaleString("id-ID")
                                                                : "";
                                                            if (decimal !== undefined) {
                                                                formatted += "," + decimal;
                                                            }
                                                            return formatted;
                                                        })()
                                                        : ""
                                                }
                                                onChange={(e) => {
                                                    let input = e.target.value;

                                                    // Remove all except digits and comma
                                                    input = input.replace(/[^0-9,]/g, "");

                                                    // Split integer and decimal part
                                                    const [intPart, decimalPart] = input.split(",");

                                                    // Format integer part with thousand separator
                                                    let formatted = "";
                                                    if (intPart) {
                                                        const parsed = parseInt(intPart, 10);
                                                        formatted = isNaN(parsed)
                                                            ? ""
                                                            : parsed.toLocaleString("id-ID");
                                                    }
                                                    if (decimalPart !== undefined) {
                                                        formatted += "," + decimalPart;
                                                    }

                                                    // Raw value for backend: replace comma with dot
                                                    const rawValue =
                                                        decimalPart !== undefined
                                                            ? `${intPart}.${decimalPart}`
                                                            : intPart;

                                                    setValue("qty_opname", rawValue);
                                                }}
                                                InputLabelProps={{ shrink: true }}
                                                inputProps={{ inputMode: "decimal" }}
                                            />
                                        )}
                                    />
                                    {errors.qty_opname && (
                                        <FormHelperText sx={{ color: "error.main" }}>
                                            Form ini tidak boleh kosong.
                                        </FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>

                            {/* KETERANGAN */}
                            <Grid item xs={12} sm={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name="keterangan_detail"
                                        control={control}
                                        rules={{ required: false }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                inputProps={{ readOnly: true }}
                                                fullWidth
                                                label="Keterangan Opname"
                                                value={value}
                                                disabled
                                                onChange={onChange}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.keterangan_detail && (
                                        <FormHelperText sx={{ color: "error.main" }}>
                                            Form ini tidak boleh kosong.
                                        </FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions className='dialog-actions-dense'>
                        <Button variant='contained' type='submit'>Simpan</Button>
                        <Button onClick={() => setOpenDialogBaru(false)}>Batal</Button>
                    </DialogActions>
                </form>
            </Dialog>
            <Dialog
                maxWidth={'md'}
                fullWidth={true}
                open={openDialogExisting}
                onClose={() => setOpenDialogExisting(false)}
                aria-labelledby='form-dialog-title'
            >
                <form onSubmit={handleSubmit((data) => {
                    setOpenDialogExisting(false)
                    let url = apiUrl.apiUrl + '/mm/opname-kain/save-detail-existing/' + id;
                    axios.post(url, data, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                        .then(response => {
                            if (response.data.success) {
                                showToast(response.data.message, 'success');
                                window.open(
                                    `${apiUrl.baseUrl}/mm/batch/cetak-label-batch/${response.data.batch_id}`,
                                    '_blank'
                                );
                                getDetail();
                            } else {
                                showToast(response.data.message, 'error');
                                setOpenDialog(false);
                            }
                        })
                        .catch(error => {
                            showToast(error.message, 'error');
                        });
                })}>
                    <DialogTitle id='form-dialog-title'>
                        <Typography variant='h6' sx={{ fontWeight: 500, color: '#212121' }}>
                            Tambah Existing Opname
                        </Typography>
                    </DialogTitle>
                    <DialogContent dividers>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={12}>
                                <FormControl fullWidth>
                                    <Autocomplete
                                        value={valBatch}
                                        options={listBatch}
                                        id='batch'
                                        isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                        getOptionLabel={(option: any) => option.nama_barang || ""}   // ? tampilkan nama
                                        onChange={handleChangeAutocompleteBatch}
                                        filterOptions={filterOptions}
                                        renderOption={(props: any, option: any) => {
                                            return (
                                                <li {...props} key={option.id}>
                                                    {option.id} | {option.nama_barang} | Stock : {option.stock_saat_ini} {option.satuan}
                                                </li>
                                            )
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                required
                                                label='Batch'
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name="qty_stock"
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                inputProps={{ readOnly: true }}
                                                fullWidth
                                                label="Quantity System / Stock"
                                                value={value}
                                                onChange={onChange}
                                                InputLabelProps={{ shrink: true }}
                                                disabled
                                            />
                                        )}
                                    />
                                    {errors.qty_stock && (
                                        <FormHelperText sx={{ color: "error.main" }}>
                                            Form ini tidak boleh kosong.
                                        </FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            {/* QTY ADJUSTMENT */}
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name="qty_doc"
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                inputProps={{ readOnly: true }}
                                                fullWidth
                                                label="Quantity Adjustment"
                                                type="number"
                                                value={value}
                                                disabled
                                                onChange={onChange}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.qty_doc && (
                                        <FormHelperText sx={{ color: "error.main" }}>
                                            Form ini tidak boleh kosong.
                                        </FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>

                            {/* QTY OPNAME */}
                            <Grid item xs={12} sm={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name="qty_opname"
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                fullWidth
                                                label="Quantity Opname"
                                                name="qty_opname"
                                                value={
                                                    value !== undefined && value !== null && value !== ""
                                                        ? (() => {
                                                            // Format value for display: replace dot with comma, add thousand separator
                                                            const str = String(value).replace(".", ",");
                                                            const [integer, decimal] = str.split(",");
                                                            let formatted = integer
                                                                ? Number(integer).toLocaleString("id-ID")
                                                                : "";
                                                            if (decimal !== undefined) {
                                                                formatted += "," + decimal;
                                                            }
                                                            return formatted;
                                                        })()
                                                        : ""
                                                }
                                                onChange={(e) => {
                                                    let input = e.target.value;

                                                    // Remove all except digits and comma
                                                    input = input.replace(/[^0-9,]/g, "");

                                                    // Split integer and decimal part
                                                    const [intPart, decimalPart] = input.split(",");

                                                    // Format integer part with thousand separator
                                                    let formatted = "";
                                                    if (intPart) {
                                                        const parsed = parseInt(intPart, 10);
                                                        formatted = isNaN(parsed)
                                                            ? ""
                                                            : parsed.toLocaleString("id-ID");
                                                    }
                                                    if (decimalPart !== undefined) {
                                                        formatted += "," + decimalPart;
                                                    }

                                                    // Raw value for backend: replace comma with dot
                                                    const rawValue =
                                                        decimalPart !== undefined
                                                            ? `${intPart}.${decimalPart}`
                                                            : intPart;

                                                    setValue("qty_opname", rawValue);
                                                }}
                                                InputLabelProps={{ shrink: true }}
                                                inputProps={{ inputMode: "decimal" }}
                                            />
                                        )}
                                    />
                                    {errors.qty_opname && (
                                        <FormHelperText sx={{ color: "error.main" }}>
                                            Form ini tidak boleh kosong.
                                        </FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>

                            {/* KETERANGAN */}
                            <Grid item xs={12} sm={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name="keterangan_detail"
                                        control={control}
                                        rules={{ required: false }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                inputProps={{ readOnly: true }}
                                                fullWidth
                                                label="Keterangan Opname"
                                                value={value}
                                                disabled
                                                onChange={onChange}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.keterangan_detail && (
                                        <FormHelperText sx={{ color: "error.main" }}>
                                            Form ini tidak boleh kosong.
                                        </FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions className='dialog-actions-dense'>
                        <Button variant='contained' type='submit'>Simpan</Button>
                        <Button onClick={() => setOpenDialogExisting(false)}>Batal</Button>
                    </DialogActions>
                </form>
            </Dialog>
            <Dialog
                maxWidth={'sm'}
                fullWidth={true}
                open={openDialog}
                onClose={() => setOpenDialog(false)}
                aria-labelledby='form-dialog-title'
            >
                <form onSubmit={handleSubmit((data) => {
                    setOpenDialog(false)
                    let url = apiUrl.apiUrl + '/mm/opname-kain/edit-detail/' + id;
                    axios.post(url, data, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                        .then(response => {
                            if (response.data.success) {
                                showToast(response.data.message, 'success');
                                window.open(
                                    `${apiUrl.baseUrl}/mm/batch/cetak-label-batch/${response.data.batch_id}`,
                                    '_blank'
                                );
                                getDetail();
                            } else {
                                showToast(response.data.message, 'error');
                                setOpenDialog(false);
                            }
                        })
                        .catch(error => {
                            showToast(error.message, 'error');
                        });
                })}>
                    <DialogTitle id='form-dialog-title'>
                        <Typography variant='h6' sx={{ fontWeight: 500, color: '#212121' }}>
                            Edit Opname
                        </Typography>
                    </DialogTitle>
                    <DialogContent dividers>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name="barang"
                                        control={control}
                                        rules={{ required: false }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                fullWidth
                                                inputProps={{ readOnly: true }}
                                                label="Barang"
                                                value={value}
                                                onChange={onChange}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.barang && (
                                        <FormHelperText sx={{ color: "error.main" }}>
                                            Form ini tidak boleh kosong.
                                        </FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            {/* QTY ADJUSTMENT */}
                            <Grid item xs={12} sm={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name="qty_doc"
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                inputProps={{ readOnly: true }}
                                                fullWidth
                                                label="Quantity Adjustment"
                                                type="number"
                                                value={value}
                                                onChange={onChange}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.qty_doc && (
                                        <FormHelperText sx={{ color: "error.main" }}>
                                            Form ini tidak boleh kosong.
                                        </FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>

                            {/* QTY OPNAME */}
                            <Grid item xs={12} sm={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name="qty_opname"
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                fullWidth
                                                label="Quantity Opname"
                                                name="qty_opname"
                                                value={
                                                    value !== undefined && value !== null && value !== ""
                                                        ? (() => {
                                                            // Format value for display: replace dot with comma, add thousand separator
                                                            const str = String(value).replace(".", ",");
                                                            const [integer, decimal] = str.split(",");
                                                            let formatted = integer
                                                                ? Number(integer).toLocaleString("id-ID")
                                                                : "";
                                                            if (decimal !== undefined) {
                                                                formatted += "," + decimal;
                                                            }
                                                            return formatted;
                                                        })()
                                                        : ""
                                                }
                                                onChange={(e) => {
                                                    let input = e.target.value;

                                                    // Remove all except digits and comma
                                                    input = input.replace(/[^0-9,]/g, "");

                                                    // Split integer and decimal part
                                                    const [intPart, decimalPart] = input.split(",");

                                                    // Format integer part with thousand separator
                                                    let formatted = "";
                                                    if (intPart) {
                                                        const parsed = parseInt(intPart, 10);
                                                        formatted = isNaN(parsed)
                                                            ? ""
                                                            : parsed.toLocaleString("id-ID");
                                                    }
                                                    if (decimalPart !== undefined) {
                                                        formatted += "," + decimalPart;
                                                    }

                                                    // Raw value for backend: replace comma with dot
                                                    const rawValue =
                                                        decimalPart !== undefined
                                                            ? `${intPart}.${decimalPart}`
                                                            : intPart;

                                                    setValue("qty_opname", rawValue);
                                                }}
                                                InputLabelProps={{ shrink: true }}
                                                inputProps={{ inputMode: "decimal" }}
                                            />
                                        )}
                                    />
                                    {errors.qty_opname && (
                                        <FormHelperText sx={{ color: "error.main" }}>
                                            Form ini tidak boleh kosong.
                                        </FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>

                            {/* KETERANGAN */}
                            <Grid item xs={12} sm={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name="keterangan_detail"
                                        control={control}
                                        rules={{ required: false }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                fullWidth
                                                label="Keterangan Opname"
                                                value={value}
                                                inputProps={{ readOnly: true }}
                                                onChange={onChange}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.keterangan_detail && (
                                        <FormHelperText sx={{ color: "error.main" }}>
                                            Form ini tidak boleh kosong.
                                        </FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions className='dialog-actions-dense'>
                        <Button variant='contained' type='submit'>Simpan</Button>
                        <Button onClick={() => setOpenDialog(false)}>Batal</Button>
                    </DialogActions>
                </form>
            </Dialog>
        </Grid>
    )
}
